import { PredictionUser } from 'state/types'
import styled from 'styled-components'
import MobileRow from './MobileRow'

interface MobileResultsProps {
  results: PredictionUser[]
}

const MobileResults: React.FC<React.PropsWithChildren<MobileResultsProps>> = ({ results }) => {
  return (
    <StyleBox>
      {results.map((result, index) => (
        <MobileRow key={result.id} rank={index + 4} user={result} />
      ))}
    </StyleBox>
  )
}

const StyleBox = styled.div`
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 16px;
  @media screen and (max-width: 700px) {
    margin-left: 16px;
    margin-right: 16px;
  }
`
export default MobileResults
